import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import React, { memo } from 'react';

import { FormattedMessage } from '../../../util/reactIntl';

const SearchFiltersSecondaryComponentStyles = {
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
};

const buttonWrapperStyles = {
  position: 'sticky',
  top: 100,
  padding: '24px 0',
  margin: '24px 0',
};

const SearchFiltersSecondaryComponent = ({
  cancelFilters: cancelFiltersFn,
  resetAll: resetAllFn,
  applyFilters,
  onClosePanel,
  children,
}) => {
  const applyFiltersWrapper = () => {
    // Ensure that panel closes (if now changes have been made)
    applyFilters();
    onClosePanel();
  };

  const cancelFilters = () => {
    if (cancelFiltersFn) {
      cancelFiltersFn();
    }
    onClosePanel();
  };

  const resetAll = (e) => {
    if (resetAllFn) {
      resetAllFn(e);
    }
    // Ensure that panel closes (if now changes have been made)
    onClosePanel();
    // blur event target if event is passed
    if (e && e.currentTarget) {
      e.currentTarget.blur();
    }
  };

  return (
    <Box sx={SearchFiltersSecondaryComponentStyles}>
      <Box flex={1}>{children}</Box>
      <Box sx={{ position: 'relative', marginLeft: 4 }}>
        <Stack spacing={2} sx={buttonWrapperStyles}>
          <Button color="secondary" onClick={applyFiltersWrapper} variant="outlined">
            <FormattedMessage id="SearchFiltersSecondary.apply" />
          </Button>
          <Button color="secondary" onClick={cancelFilters} variant="outlined">
            <FormattedMessage id="SearchFiltersSecondary.cancel" />
          </Button>
          <Button color="secondary" onClick={resetAll} variant="outlined">
            <FormattedMessage id="SearchFiltersSecondary.resetAll" />
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

SearchFiltersSecondaryComponent.displayName = 'SearchFiltersSecondary';

const SearchFiltersSecondary = memo(SearchFiltersSecondaryComponent);

export default SearchFiltersSecondary;
